export class VendersFilterEntity {
  id?: number
  name?: string
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
  searchWord?: string
}
